import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

import { LocationRowData } from '../useLocationsTable'
import { ActionsTd, RowActions, Td } from '../../styled-components'

interface LocationRowProps {
  row: LocationRowData
  editLabel: string
  deleteLabel: string
}

const LocationRow = ({ row, editLabel, deleteLabel }: LocationRowProps) => (
  <tr>
    <Td>{row.code}</Td>
    <Td>{row.name}</Td>
    <ActionsTd>
      <RowActions>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton id={`fiscal-code-${row.id}-edit-btn`} block={false} onClick={row.onEdit}>
          {editLabel}
        </SDButton>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton id={`fiscal-code-${row.id}-delete-btn`} block={false} onClick={row.onDelete}>
          {deleteLabel}
        </SDButton>
      </RowActions>
    </ActionsTd>
  </tr>
)

export default LocationRow
